import componentLoader from './component-loader';

componentLoader.loadComponents(window.document.body);
